var React = require('react');

function Shopping (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon_shopping"},React.createElement("path",{"id":"Shape","fillRule":"evenodd","clipRule":"evenodd","d":"M20.0013 6.1543C17.1254 6.1543 14.7798 8.49987 14.7798 11.3757V13.9865H12.1691C11.6452 13.9865 11.236 14.4836 11.1901 14.8737L9.55837 32.4961C9.50738 33.0379 9.99306 33.5695 10.5374 33.5669H29.4651C30.0095 33.5707 30.4951 33.0379 30.4442 32.4961L28.8125 14.8737C28.7666 14.3918 28.3166 13.9839 27.8334 13.9865H25.2227V11.3757C25.2227 8.49987 22.8771 6.1543 20.0013 6.1543ZM20.002 8.111C21.8275 8.111 23.2654 9.54892 23.2654 11.3744V13.9851H16.7386V11.3744C16.7386 9.54892 18.1765 8.111 20.002 8.111ZM26.9341 15.9437H13.0647L11.6165 31.608H28.3823L26.9341 15.9437Z"})));
}

Shopping.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Shopping;

Shopping.default = Shopping;
